import { Button } from 'antd';
import PropTypes from 'prop-types';
import React, { useMemo, useState } from "react";
import { useFetcher, useLoaderData } from 'react-router-dom';
// import { Box } from '../../../components/design/box.js';
import { DatePicker, FieldWrapper, InputWrapper } from "../../../components/inputs";

import { Box } from '../../../components/design';
import { formatDeliveryAddress } from '../../../library/helpers';
import { formatDate } from '../../../library/utils/intl.js';
import styles from "./expected-dispatch-date.module.scss";
import MissingFinisherAddress from './missingFinisherAddress.jsx';
import InfoLabel, { DATE_HELP } from '../../../components/data/info-label.jsx';

export const ShipmentConfirmDispatchDate = ({ shipment }) => {
    const fetcher = useFetcher()
    const [selectedQuantity, setSelectedQuantity] = useState(shipment.ship_quantity ?? shipment.quantity)
    const { errors = {} } = fetcher.data || {}

    const quantityValidationMessage = useMemo(() => {
        if (!selectedQuantity) {
            return
        }
        if (selectedQuantity < (shipment.quantity * 0.9)) {
            return 'Dispatch quantity is less than 10% of confirmed quantity'
        }
        if (selectedQuantity > (shipment.quantity * 1.1)) {
            return 'Dispatch quantity cannot be greater than 10% of confirmed quantity'
        }
    }, [shipment.quantity, selectedQuantity])

    const getAddress = (shipment) => {
        return <>{formatDeliveryAddress(shipment)}</>
    }
    return (
        <fetcher.Form method="post" encType={'application/x-www-form-urlencoded'}>
            <div className={styles.deliveryRow}>
                <div className="quantity">{shipment.quantity}</div>
                <div className="address">{getAddress(shipment)}</div>
                <div className="field-expected_date">
                    {formatDate(shipment.dispatch_date)}
                </div>
                <div className="field-quantity">
                    <InputWrapper type='Number' min={0} name="ship_quantity" defaultValue={shipment.ship_quantity ?? shipment.quantity} onChange={(e) => {
                        setSelectedQuantity(e.target.value)
                    }} errors={errors} />
                    <span className="error" style={{ color: "red" }}>{quantityValidationMessage}</span>
                </div>

                <>
                    <div className="field-trackingurl">
                        <InputWrapper name="tracking_url" defaultValue={shipment.tracking_url} placeholder="https://" errors={errors} />
                    </div>
                    <div className="field-expected_delivery_date">
                        <FieldWrapper name="" errors={errors} >
                            <DatePicker name="expected_delivery_date" useHidden value={shipment.expected_date} />
                        </FieldWrapper>
                    </div>
                </>

                <Button
                    type="primary"
                    htmlType='submit'
                    name="action"
                    value='updateDeliveryInformationByVendor'
                    loading={fetcher.state !== 'idle'}
                    disabled={!!quantityValidationMessage}
                >Submit</Button>
            </div>
        </fetcher.Form>
    )
}
ShipmentConfirmDispatchDate.propTypes = {
    shipment: PropTypes.object.isRequired
}


const ExpectedDeliveryDate = () => {
    const { productionDetails } = useLoaderData()
    const delivery = productionDetails.item_delivery_address?.[0]
    if (!delivery) return <MissingFinisherAddress />

    return <div className={styles.container}>
        <h3>Task For You</h3>
        <Box header={
            <div className={styles.deliveryRowHead}>
                <div>Quantity</div>
                <div>Delivery Address</div>
                <div><InfoLabel label="Expected Dispatch Date" info={DATE_HELP.supplierDispatch} /></div>
                <div>Ship Quantity</div>
                <div>Tracking URL <span style={{ color: "red" }} aria-hidden="true">*</span></div>
                <div><InfoLabel label="Expected Delivery Date" info={DATE_HELP.supplierDelivery} /></div>
                <div></div>
            </div>
        }>
            <ShipmentConfirmDispatchDate shipment={delivery} />
        </Box>
    </div>
}


export default ExpectedDeliveryDate




// import { CheckOutlined } from '@ant-design/icons';
// import { Button, Tooltip } from 'antd';
// import PropTypes from 'prop-types';
// import React from "react";
// import { useFetcher, useLoaderData } from 'react-router-dom';
// import { Box } from '../../../components/design/box';
// import { DatePicker, FieldWrapper, InputWrapper } from "../../../components/inputs";
// import styles from "./expected-dispatch-date.module.scss";
// import { formatDate } from '../../../library/utils';

// const DeliveryTrackingRow = ({ item }) => {
//     const fetcher = useFetcher()
//     const { errors = {} } = fetcher.data || {}
//     return (
//         <fetcher.Form method="post">
//             <input type="hidden" name="shipment_id" value={item.id} />
//             <div className={styles.deliveryRow}>
//                 <div className="quantity">{item.quantity}</div>
//                 <div className="address">{item.street_number},{item.street},{item.city}</div>
//                 <div className="field-quantity">
//                     <InputWrapper type='Number' min={0} name="ship_quantity" defaultValue={item.ship_quantity} errors={errors} />
//                 </div>
//                 <div className="field-trackingurl">
//                     <InputWrapper name="tracking_url" defaultValue={item.tracking_url} errors={errors} />
//                 </div>
//                 <div className="field-expecteddate">
//                     <FieldWrapper name="expected_date" errors={errors} >
//                         <DatePicker name="expected_date" value={item.expected_date} useHidden />
//                     </FieldWrapper>
//                 </div>
//                 <div>{formatDate(item.dispatch_date)}</div>
//                 <Tooltip title={"Click on this box to send the shipped quantity, track and trace (if available), and dispatch date to Leoprinting"}>
//                     <Button
//                         type="primary"
//                         htmlType='submit'
//                         name="action"
//                         value="updateDeliveryInformation"
//                         icon={<CheckOutlined />}
//                         loading={fetcher.state !== 'idle'}
//                     />
//                 </Tooltip>
//             </div>
//         </fetcher.Form>
//     )
// }
// DeliveryTrackingRow.propTypes = {
//     item: PropTypes.object.isRequired
// }

// const ExpecetedDispatchDate = () => {
//     const { deliveryDetails } = useLoaderData()
//     return (
//         <div className={styles.container}>
//             <h3>Task For You</h3>
//             <Box header={
//                 <div className={styles.deliveryRowHead}>
//                     <div>Quantity</div>
//                     <div>Delivery Address</div>
//                     <div>Ship Quantity</div>
//                     <div>Tracking URL</div>
//                     <div>Expected Delivery Date</div>
//                     <div>Expected Dispatch Date</div>
//                     <div></div>
//                 </div>
//             }>
//                 {deliveryDetails && deliveryDetails.map((shipment) => <DeliveryTrackingRow key={shipment.id} item={shipment} />)}
//             </Box>
//         </div>
//     )
// }


// export default ExpecetedDispatchDate;



